import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';

const AnalyticsDateFilter = ({ filterOption, filterMenu, keyParam, onFieldChange, onFocusChange, error }) => {
    const config = filterMenu[keyParam];

    const maxDate = config.maxDateKey && filterOption[config.maxDateKey]
        ? moment(filterOption[config.maxDateKey])
        : (config.disableFuture ? moment() : undefined);
    const minDate = config.minDateKey && filterOption[config.minDateKey]
        ? moment(filterOption[config.minDateKey])
        : undefined;

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
                label={config.title}
                views={config.views || ['year', 'month', 'day']}
                format={config.format || fieldDateFormat}
                disableFuture={!!config.disableFuture}
                minDate={minDate}
                maxDate={maxDate}
                value={filterOption[keyParam] ? moment(filterOption[keyParam]) : null}
                onChange={(data) =>
                    onFieldChange(
                        keyParam,
                        data && moment(data).isValid() ? moment(data).format(config.format || backendDateFormat) : null
                    )
                }
                slotProps={{
                    textField: {
                        InputLabelProps: { shrink: true },
                        fullWidth: true,
                        size: 'small',
                        margin: 'normal',
                        variant: 'outlined',
                        error: !!error,
                        helperText: error || undefined,
                        onFocus: () => onFocusChange?.(keyParam),
                    },
                    field: {
                        clearable: true,
                        onClear: () => onFieldChange(keyParam, null),
                    },
                }}
                sx={{ mt: 2.5, width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '5px' } }}
            />
        </LocalizationProvider>
    );
};

export default AnalyticsDateFilter;
